export default "__VITE_ASSET__44e81df3__"